export const CAMPO_OBLIGATORIO = 'Campo obligatorio'

export const REST_API_PROVINCIAS = process.env.VUE_APP_BASE_API + 'data/provincias'
export const REST_API_CALCULAR_AHORRO = process.env.VUE_APP_BASE_API + 'calculador/calcular_ahorro'
